import { motion } from "framer-motion";

const MOODS = [
  { emoji: "😭", label: "I need a good cry", prompt: "I haven't read anything in a while but honestly I'm in the mood to just… feel something. Like ugly-cry-on-the-couch kind of feeling." },
  { emoji: "🌙", label: "Can't sleep anyway", prompt: "I've been in a reading slump but I want something that'll keep me up till 3am. The kind of book where you look up and it's suddenly morning." },
  { emoji: "🪐", label: "Something weird", prompt: "I'm bored of normal books. I want something genuinely strange — like, make me question reality a little bit." },
  { emoji: "🌿", label: "Slow & quiet", prompt: "I've been reading a lot of fast-paced stuff and I kind of want the opposite. Something slow, beautiful, where nothing really happens but everything matters." },
  { emoji: "💛", label: "Fix my brain", prompt: "Everything is terrible and I need a book that makes me believe in people again. Something warm without being cheesy." },
  { emoji: "🔥", label: "Wreck me", prompt: "I want a book that's going to mess me up in a good way. Something bold that I'll be thinking about for weeks." },
  { emoji: "👻", label: "Beautifully dark", prompt: "I'm drawn to dark stuff but I want it to be well-written, you know? Not just shock value. Like, atmospheric and haunting." },
  { emoji: "🤷", label: "Surprise me", prompt: "I honestly have no idea what I want. Just pick something great and tell me why I need to read it." },
];

interface MoodChipsProps {
  onSelect: (prompt: string) => void;
  disabled?: boolean;
}

export default function MoodChips({ onSelect, disabled }: MoodChipsProps) {
  return (
    <div className="flex flex-wrap justify-center gap-2.5">
      {MOODS.map((mood, i) => (
        <motion.button
          key={mood.label}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 + i * 0.06, duration: 0.4, ease: "easeOut" }}
          onClick={() => onSelect(mood.prompt)}
          disabled={disabled}
          className="mood-chip rounded-full border border-border/60 bg-card/80 px-4 py-2.5 text-sm font-medium text-foreground backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span className="mr-1.5">{mood.emoji}</span>
          {mood.label}
        </motion.button>
      ))}
    </div>
  );
}
